// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"426":"b7dfdcf0","861":"abc658a9"}[chunkId] + ".css";
};